// SEO metadata for all pages
export const seoData = {
  home: {
    tr: {
      title: 'Ener Otomasyon | Enerji Otomasyonu, Senkronizasyon, Woodward, SCADA',
      description: 'Ener Otomasyon; enerji otomasyonu, senkronizasyon panosu, senkron kartı, Woodward, Deif, Easygen, AGC150, ComAp, DeepSea ve SCADA çözümlerinde uzman ekip ile hizmet verir.',
      keywords: 'ener otomasyon, enerji otomasyonu, senkronizasyon, senkron panosu, woodward, easygen, deif, agc150, comap, deepsea, senkron kartı, scada, eselfware, jeneratör senkronizasyonu, İzmir'
    },
    en: {
      title: 'Ener Automation | Synchronization, Woodward, SCADA, HMI, Energy Automation',
      description: 'Synchronization panels, Woodward, Deif, Easygen cards, SCADA, HMI, PLC systems, energy automation, electrical panels. 15+ years experience, 1000+ projects. Industrial automation leader in Izmir.',
      keywords: 'synchronization, woodward, deif, easygen, SCADA, HMI, sync panel, energy automation, automation systems, PLC, generator synchronization, electrical panels, industrial automation, Izmir, Gaziemir'
    }
  },
  services: {
    tr: {
      title: 'Hizmetlerimiz | Senkronizasyon Panosu, AGC150, ComAp, DeepSea, SCADA',
      description: 'Senkronizasyon, senkron panosu, Woodward, Deif, Easygen, AGC150, ComAp, DeepSea, senkron kartı ve SCADA tabanlı enerji otomasyonu hizmetleri sunuyoruz.',
      keywords: 'senkronizasyon panosu, woodward, deif, easygen, agc150, comap, deepsea, senkron kartı, scada, enerji otomasyonu, jeneratör senkronizasyonu, eselfware'
    },
    en: {
      title: 'Our Services | Synchronization Panel, SCADA, HMI, Woodward - Ener Automation',
      description: 'Synchronization panels, Woodward cards, Deif, Easygen, SCADA systems, HMI design, PLC programming, energy automation and electrical panels. Professional industrial automation solutions.',
      keywords: 'synchronization panel, woodward cards, deif sync, easygen controller, SCADA systems, HMI programming, PLC automation, energy automation, sync panel, generator synchronization, electrical panels, industrial automation, Izmir'
    }
  },
  projects: {
    tr: {
      title: 'Projelerimiz | Tamamlanan Otomasyon Projeleri - Ener Otomasyon',
      description: '1000+ tamamlanmış endüstriyel otomasyon ve elektrik projesi. Referanslarımız ve başarı hikayelerimiz.',
      keywords: 'otomasyon projeleri, referanslar, endüstriyel projeler, elektrik projeleri, başarılı projeler'
    },
    en: {
      title: 'Our Projects | Completed Automation Projects - Ener Automation',
      description: '1000+ completed industrial automation and electrical projects. Our references and success stories.',
      keywords: 'automation projects, references, industrial projects, electrical projects, successful projects'
    }
  },
  blog: {
    tr: {
      title: 'Blog | Otomasyon ve Elektrik Haberleri - Ener Otomasyon',
      description: 'Endüstriyel otomasyon, elektrik sistemleri, enerji yönetimi ve teknoloji hakkında güncel haberler ve makaleler.',
      keywords: 'otomasyon blog, elektrik haberleri, enerji yönetimi, teknik makaleler, sektör haberleri'
    },
    en: {
      title: 'Blog | Automation and Electrical News - Ener Automation',
      description: 'Current news and articles about industrial automation, electrical systems, energy management and technology.',
      keywords: 'automation blog, electrical news, energy management, technical articles, industry news'
    }
  },
  about: {
    tr: {
      title: 'Hakkımızda | Senkronizasyon ve Otomasyon Uzmanı - Ener Otomasyon',
      description: 'Ener Otomasyon, 15+ yıldır enerji otomasyonu, senkronizasyon, Woodward, Deif, Easygen, AGC150, ComAp, DeepSea, senkron kartı ve SCADA projeleri gerçekleştirmektedir.',
      keywords: 'ener otomasyon, enerji otomasyonu, senkronizasyon uzmanı, woodward, deif, easygen, agc150, comap, deepsea, senkron kartı, scada, eselfware, İzmir'
    },
    en: {
      title: 'About Us | Synchronization and Automation Expert - Ener Automation',
      description: 'Ener Automation has been providing Woodward, Deif, Easygen synchronization systems, SCADA, HMI, PLC automation and energy management solutions for 15+ years. Expert team in Izmir.',
      keywords: 'ener automation, synchronization expert, woodward authorized, deif distributor, automation company, SCADA specialist, HMI programming, Izmir, Gaziemir'
    }
  },
  contact: {
    tr: {
      title: 'İletişim | Ener Otomasyon - İzmir',
      description: 'Ener Otomasyon ile iletişime geçin. Adres: Fatih Mah, 1197. Sk. No:2/1, Gaziemir/İzmir. Tel: +90 232 433 1 435',
      keywords: 'iletişim, adres, telefon, e-posta, İzmir, Gaziemir, ener otomasyon iletişim'
    },
    en: {
      title: 'Contact | Ener Automation - Izmir',
      description: 'Contact Ener Automation. Address: Fatih Mah, 1197. Sk. No:2/1, Gaziemir/Izmir. Tel: +90 232 433 1 435',
      keywords: 'contact, address, phone, email, Izmir, Gaziemir, ener automation contact'
    }
  },
  faq: {
    tr: {
      title: 'Sıkça Sorulan Sorular | Ener Otomasyon',
      description: 'Endüstriyel otomasyon, elektrik sistemleri ve hizmetlerimiz hakkında sıkça sorulan sorular ve cevapları.',
      keywords: 'SSS, sorular, cevaplar, otomasyon soruları, elektrik soruları'
    },
    en: {
      title: 'Frequently Asked Questions | Ener Automation',
      description: 'Frequently asked questions and answers about industrial automation, electrical systems and our services.',
      keywords: 'FAQ, questions, answers, automation questions, electrical questions'
    }
  },
  career: {
    tr: {
      title: 'Kariyer | İş İlanları - Ener Otomasyon',
      description: 'Ener Otomasyon kariyer fırsatları. Açık pozisyonlar ve iş başvuruları.',
      keywords: 'kariyer, iş ilanları, açık pozisyonlar, iş başvurusu, otomasyon mühendisi, elektrik mühendisi'
    },
    en: {
      title: 'Career | Job Openings - Ener Automation',
      description: 'Ener Automation career opportunities. Open positions and job applications.',
      keywords: 'career, job openings, open positions, job application, automation engineer, electrical engineer'
    }
  },
  certificates: {
    tr: {
      title: 'Sertifikalar | Ener Otomasyon',
      description: 'Ener Otomasyon sertifikaları, belgeler ve akreditasyonlar.',
      keywords: 'sertifikalar, belgeler, akreditasyon, kalite belgeleri'
    },
    en: {
      title: 'Certificates | Ener Automation',
      description: 'Ener Automation certificates, documents and accreditations.',
      keywords: 'certificates, documents, accreditation, quality certificates'
    }
  },
  quote: {
    tr: {
      title: 'Teklif Alın | Ener Otomasyon',
      description: 'Endüstriyel otomasyon ve elektrik projeleriniz için ücretsiz teklif alın. Hızlı geri dönüş garantisi.',
      keywords: 'teklif, fiyat teklifi, proje teklifi, ücretsiz teklif'
    },
    en: {
      title: 'Get a Quote | Ener Automation',
      description: 'Get a free quote for your industrial automation and electrical projects. Fast response guarantee.',
      keywords: 'quote, price quote, project quote, free quote'
    }
  }
};
